import axios from "./axios";

class FinoDmtService {
  bioDeviceConfig = async () => {
    try {
      const response = await axios.post("/ppi_dmt/bio_device_config", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  generateMerchantOnboardUrl = async () => {
    try {
      const response = await axios.post(
        "/fino_dmt/merchant/generate_onboard_url",
        {},
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  merchantOnboardStatus = async () => {
    try {
      const response = await axios.post(
        "/fino_dmt/merchant/onboard_status",
        {},
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  finoEkyc = async (aadhaar, dob, bio_data, latitude, longitude) => {
    try {
      const response = await axios.post("/fino_dmt/merchant/fino_ekyc", {
        aadhaar,
        dob,
        bio_data,
        latitude,
        longitude,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  finoBcStatus = async () => {
    try {
      const response = await axios.post(
        "/fino_dmt/merchant/fino_bc_status",
        {},
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  fetchCommercial = async (amount) => {
    try {
      const response = await axios.post("/fino_dmt/fetch_commercial", {
        amount,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  bankList = async (mobile) => {
    try {
      const response = await axios.post("/fino_dmt/bank_list", {
        mobile,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  queryRemitter = async (mobile) => {
    try {
      const response = await axios.post("/fino_dmt/query_remitter", {
        mobile: mobile,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  beneList = async (mobile) => {
    try {
      const response = await axios.post("/fino_dmt/bene/list", {
        mobile,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  addBeneSendOtp = async (
    mobile,
    bene_name,
    bank_id,
    account_no,
    ifsc_code,
  ) => {
    try {
      const response = await axios.post("/fino_dmt/bene/add_bene_send_otp", {
        mobile,
        bene_name,
        bank_id,
        account_no,
        ifsc_code,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  addBeneVerifyOtp = async (
    mobile,
    bene_name,
    bank_id,
    account_no,
    ifsc_code,
    otp,
    token,
  ) => {
    try {
      const response = await axios.post("/fino_dmt/bene/add_bene_verify_otp", {
        mobile,
        bene_name,
        bank_id,
        account_no,
        ifsc_code,
        otp,
        token,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  deleteBene = async (mobile, bene_id) => {
    try {
      const response = await axios.post("/fino_dmt/bene/delete", {
        mobile,
        bene_id,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  pennyDrop = async (
    mobile,
    bene_name,
    bene_id,
    bank_id,
    account_no,
    ifsc_code,
  ) => {
    try {
      const response = await axios.post("/fino_dmt/penny_drop", {
        mobile,
        bene_name,
        bene_id,
        bank_id,
        account_no,
        ifsc_code,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  transactionSendOtp = async (mobile, bene_id, amount) => {
    try {
      const response = await axios.post("/fino_dmt/transaction/send_otp", {
        mobile,
        bene_id,
        amount,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  transactionVerifyOtp = async (
    mobile,
    bene_id,
    bank_name,
    bene_name,
    account,
    ifsc,
    mode,
    amount,
    otp,
    token,
  ) => {
    try {
      const response = await axios.post("/fino_dmt/transaction/verify_otp", {
        mobile,
        bene_id,
        bank_name,
        bene_name,
        account,
        ifsc,
        mode,
        amount,
        otp,
        token,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  refundGenerateOtp = async (order_id) => {
    try {
      const response = await axios.post("/fino_dmt/refund/generate_otp", {
        order_id,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  refundVerifyOtp = async (order_id, token, otp) => {
    try {
      const response = await axios.post("/fino_dmt/refund/verify_otp", {
        order_id,
        token,
        otp,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  fundTransferHistory = async (
    from_date,
    to_date,
    search_text,
    is_init_state,
    refund_pending,
    size,
    page,
  ) => {
    try {
      const response = await axios.post("/fino_dmt/transaction/report", {
        from_date,
        to_date,
        search_text,
        is_init_state,
        refund_pending,
        size,
        page,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  downloadReceipt = async (order_id) => {
    try {
      const response = await axios.post("/fino_dmt/download_receipt", {
        order_id,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new FinoDmtService();
